import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";

export interface CreditOutletsTable {
  field: string;
  value: string;
}

@Component({
    selector: 'deal-credit-outlets-table',
    templateUrl: './credit-outlets-table.component.html',
    styleUrls: ['./credit-outlets-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreditOutletsTableComponent {
  @Input() outlets: Array<CreditOutletsTable>;
  @Input() isCalculated: boolean;

  dataColumns: string[] = ['field', 'value'];
  dataSource: MatTableDataSource<CreditOutletsTable>;

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.outlets);
  }
}
